module.exports = __webpack_public_path__ + "img/mdm-deploy-6.ad929f18.webp";